import { render } from "./PushupsGame.vue?vue&type=template&id=457630ea&scoped=true"
import script from "./PushupsGame.vue?vue&type=script&lang=js"
export * from "./PushupsGame.vue?vue&type=script&lang=js"

import "./PushupsGame.vue?vue&type=style&index=0&id=457630ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457630ea"]])

export default __exports__